import { UTMCookieSignature } from "../types/utm.type";

import { sessionDomain } from '../constants'

type CookiesType = {
  httpOnly: boolean;
  secure: boolean;
  sameSite: 'none';
  maxAge: number;
  path: string;
}

export const cookiesSettings: CookiesType = (process.env.NODE_ENV === 'production')? {
  httpOnly: false,
  secure: true,
  sameSite: 'none',
  maxAge: 259200000,
  path: '/',
  ...(sessionDomain && {domain: sessionDomain}),
} : {
  httpOnly: true,
  secure: true,
  sameSite: 'none',
  maxAge: 259200000,
  path: '/',
  ...(sessionDomain && {domain: sessionDomain}),
}

export const utmParams: Array<UTMCookieSignature> = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'utm_transaction',
  'utm_customer',
];
